const storefrontAccessToken = process.env.SHOPIFY_STOREFRONT_ACCESS_TOKEN;

//user account functions
export async function userAccount() {
	await callShopify(query);
}
async function callShopify(query) {
	const fetchUrl = `${process.env.SHOPIFY_STOREFRONT_DOMAIN}/api/2024-04/graphql.json`;

	const fetchOptions = {
		// url: fetchUrl,
		method: "POST",
		headers: {
			"X-Shopify-Storefront-Access-Token": storefrontAccessToken,
			Accept: "application/json",
			"Content-Type": "application/json",
		},
		body: JSON.stringify({ query }),
	};

	try {
		const response = await fetch(fetchUrl, fetchOptions); //.then((response) => response.json());

		const data = await response.json();

		if (data.errors) {
			console.error("An Error occurred");
			//TODO: handle errors
			console.error(data);
			throw new Error(data.error);
		} else {
			return data;
		}
	} catch (err) {
		console.error(err);
		throw new Error("Error calling Shopify api!");
	}
}

export async function getAllProductsInCollection(collection) {
	const query = `{
      collectionByHandle(handle: "${collection}") {
        id
        title
        products(first: 250) {
          edges {
            node {
              id
              title
              handle
            }
          }
        }
      }
    }`;
	const response = await callShopify(query);

	const allProducts = response.data?.collectionByHandle?.products?.edges
		? response.data?.collectionByHandle?.products?.edges
		: [];

	return allProducts;
}

export async function getProductSlugs(collection = "all") {
	const query = `{
      collectionByHandle(handle: "${collection}") {
        products(first: 250) {
          edges {
            node {
              handle
            }
          }
        }
      }
    }`;
	const response = await callShopify(query);

	const slugs = response.data.collectionByHandle.products.edges
		? response.data.collectionByHandle.products.edges
		: [];

	return slugs;
}

export async function getProduct(handle) {
	const query = `{
      productByHandle(handle: "${handle}") {
        id
        title
        handle
        description
        images(first: 250) {
          edges {
            node {
              id
              originalSrc
              height
              width     
              altText             
            }
          }
        }
        variants(first: 250) {
          edges {
            node {
              id
              title
              price                
            }
          }
        }
      }
    }`;
	const response = await callShopify(query);

	const product = response.data.productByHandle ? response.data.productByHandle : [];

	return product;
}

export async function createCheckout(localCart) {
	let formattedLineItems;

	if (Array.isArray(localCart)) {
		formattedLineItems = localCart.map((item) => {
			// const item = localCart[variantId];
			const { variantId } = item;
			const variantGuid = `gid://shopify/ProductVariant/${variantId}`;
			const variantsId = btoa(variantGuid);

			const customAttributes = item?.customAttributes?.length
				? `attributes: [${item.customAttributes?.map((c) => {
						return `{ key:"${c.key}", value:"${c.value}" }`;
				  })}],`
				: "";

			return `{
        merchandiseId: "${variantsId}",
        quantity:${item?.quantity || 0},
        ${customAttributes}
        
      
        
      }`;
		});
	} else {
		formattedLineItems = Object.keys(localCart).map((variantId) => {
			const item = localCart[variantId];
			const variantGuid = `gid://shopify/ProductVariant/${variantId}`;
			const variantsId = btoa(variantGuid);

			const customAttributes = item?.customAttributes?.length
				? `attributes: [${item.customAttributes?.map((c) => {
						return `{ key:"${c.key}", value:"${c.value}" }`;
				  })}],`
				: "";

			return `{
        merchandiseId: "${variantsId}",
        quantity:${item?.quantity || 0},
        ${customAttributes}
        
      
        
      }`;
		});
	}

	const query = `mutation 
      {
        cartCreate(input: {
          lines:  [${formattedLineItems}]
        }) {
          cart {
             id
             checkoutUrl
             lines(first: 250) {
               edges {
                 node {
                    merchandise {
                      ... on ProductVariant {
                        title
                      }
                    }
                    quantity
                  }
               }
             }
          }
          userErrors {
            field
            message
          }
        }
      }      
    `;

	try {
		const response = await callShopify(query);

		if (response.userErrors) {
			console.error(response.userErrors);
		}

		const checkout = response?.data?.cartCreate?.cart ? response.data.cartCreate.cart.checkoutUrl : false;
		return checkout;
	} catch (err) {
		console.error(err);
	}
}

export async function updateCheckout(id, lineItems) {
	const formattedLineItems = lineItems.map((item) => {
		return `{
      variantId: "${item.variantId}",
      quantity:${item.quantity}
    }`;
	});

	const query = `mutation 
      {
        checkoutLineItemsReplace(lineItems: [${formattedLineItems}], checkoutId: "${id}") {
          checkout {
             id
             webUrl
             lineItems(first: 250) {
               edges {
                 node {
                   id
                   title
                   quantity
                 }
               }
             }
          }
        }
      }      
    `;
	const response = await callShopify(query);

	const checkout = response.data.checkoutLineItemsReplace.checkout
		? response.data.checkoutLineItemsReplace.checkout
		: [];

	return checkout;
}
